import { Component, Vue } from "vue-property-decorator";
import _com from "../../../assets/js/common";
import _intercept from "../../../assets/js/intercept";

@Component
export default class couponModal extends Vue {
	conponType: any = {
		"1": "店铺券",
		"2": "商品券",
		"3": "运费券",
		"4": "充值券",
		"5": "通用券",
		"6": "品类券",
	};

	getItems: any = [];//已领取优惠券

	getCouponApi: string = "//m" + this.domain + "/mact/live/getCoupon";

	get couponData() {
		return this.$store.getters["refresh/getCoupons"];
	}
	get autoCouponData() {
		return this.$store.getters["refresh/getAutoCoupons"];
	}

	stop(e: any) {
		e.stopPropagation();
	}
	close() {
		this.$store.dispatch("environment/getIsShowConponAsync", false);
	}

	timeInter: any;
	mounted() {
		if (this.$route.name == 'couponModal') {
			this.$store.dispatch("refresh/getRecommendAsync", {
				roomNumber: this.$route.params.roomNumber,
				source: this.$route.params.source || this.source
			}
			);
			let timeNum = 0;
			clearInterval(this.timeInter);
			this.timeInter = setInterval(() => {
				//定时5秒获取一次弹幕
				timeNum++;
				if (timeNum % 10 == 0) {
					timeNum = 0;
					this.$store.dispatch("refresh/getRecommendAsync", {
						roomNumber: this.$route.params.roomNumber,
						source: this.$route.params.source || this.source
					}
					);
				}
			}, 1000)
		}
	}

	getCoupon(item: any) {
		if (!_intercept()) {
			return false;
		}
		this.$http
			.jsonp(this.getCouponApi, {
				params: {
					batchId: item.batchIdCipher,
					receiveChannelCode: "APP_COUPON_WALL",
					receiveAddress: location.href,
				},
				jsonp: "jsonCallback",
			})
			.then((res: any) => {
				res = res.body;
				if (res.code == "0000") {
					this.$toast("领取成功");
					this.getItems.push(item.batchId);
					this.$forceUpdate();
				} else {
					if (res.code == '2013') {//券已领完
						item.stock = 0
					}
					this.$toast(res.msg);
				}
			});
		// 领券埋点
		let sysid: any = ''
		if (navigator?.userAgent.includes('SYSID')) {
			sysid = navigator.userAgent.split('SYSID/')[1]
		}
		let roomData: any = this.$store.getters["getRoomDetail/getRoomDetail"];
		let scene_number = ''
		if (roomData) scene_number = roomData.scene_number
		_com.sendSensorTrack('CouponsReceive', {}, {
			sysid,
			scene_number,
			batchId: item.batchId,
			couponType: this.conponType[item.couponType],
			couponName: item.amount + '元优惠券'
		})
	}

	toUseConpon(item: any) {
		this.$store.dispatch("environment/getIsShowConponAsync", false);
		item.title = item.amount + "元商品券(不限金额使用)";
		this.$store.dispatch("environment/setBatchObjAsync", item);
		this.$store.dispatch("environment/getIfBatchTitleAsync", true);
		this.$store.dispatch("environment/getIsGoodsListAsync", true);
		this.$emit("useConpon");
	}
}
